import {
  FIRE_MODE_HOLD_COPY,
  FIRE_MODE_HOLD_TITLE,
  isFireModeHold,
} from '../../api/hooks/useFireMode';

/**
 * A refused command, said as WHAT DID NOT HAPPEN first and the server's
 * reason second. The reason is the api-server's own sentence, written
 * for a log ("fire mode is not available in this api-server process",
 * "this site has no open fire event to resolve"): shown bare, in lower
 * case, it did not tell an operator mid-evacuation whether the site was
 * frozen or not (fire-flow review 2026-10-22).
 */
export function fireErrorText(err: unknown, action: 'trigger' | 'resolve'): string {
  if (isFireModeHold(err)) return `${FIRE_MODE_HOLD_TITLE}. ${FIRE_MODE_HOLD_COPY}`;
  const reason = err instanceof Error && err.message ? err.message : null;
  const said = reason ? ` The server said: \u201c${reason}\u201d.` : '';
  return action === 'trigger'
    ? `Fire mode was NOT started, so the site is not frozen.${said} A real alarm from the building's fire panel still freezes the site by itself. If this keeps happening, call Nexsoss.`
    : `Nothing was resolved: the site is still held.${said} Close this panel and open it again to re-read the fire state; if it still will not resolve, call Nexsoss.`;
}
